<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="6">
            <!-- Description -->
            <validation-provider
              #default="validationContext"
              name="description"
              rules="required"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.description')"
                label-for="description"
              >
                <b-form-input
                  id="description"
                  v-model="itemData.description"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <!-- Reaction Patrol-->
            <validation-provider
              #default="validationContext"
              name="reaction_patrol"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.reaction_patrol')"
                label-for="reaction_patrol"
              >
                <b-form-input
                  id="reaction_patrol"
                  v-model="itemData.reaction_patrol"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <!-- TotemID -->
            <validation-provider
              #default="validationContext"
              name="idTotem"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-group :label="$t('unit.id_totem')" label-for="idTotem">
                <b-form-input
                  id="idTotem"
                  v-model="itemData.idTotem"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- TotemKey -->
            <validation-provider
              #default="validationContext"
              name="totemKey"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-group :label="$t('unit.totem_key')" label-for="totemKey">
                <b-form-input
                  id="totemKey"
                  v-model="itemData.totemKey"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <!-- Categoría (moved above REMS/SIRH) -->
            <validation-provider
              #default="validationContext"
              name="category"
              rules="required"
            >
              <b-form-group
                :label="$t('unit.category')"
                label-for="id_category"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.id_category"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="categoryOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  input-id="id_category"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- REMS -->
            <validation-provider #default="validationContext" name="rems" rules="numeric">
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.rems')"
                label-for="rems"
                v-if="$can('bank_setting', 'Units')"
              >
                <b-form-input
                  id="rems"
                  v-model="itemData.rems"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- SIRH -->
            <validation-provider #default="validationContext" name="sirh" rules="numeric">
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.sirh')"
                label-for="sirh"
                v-if="$can('bank_setting', 'Units')"
              >
                <b-form-input
                  id="sirh"
                  v-model="itemData.sirh"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <validation-provider #default="validationContext" :name="$t('unit.is_main_unit')">
              <b-form-checkbox
                v-if="$can('bank_setting', 'Units')"
                id="is_main_unit"
                v-model="itemData.is_main_unit"
                name="is_main_unit"
                class="my-1"
                switch
              >
                {{ $t("unit.is_main_unit") }}
              </b-form-checkbox>
            </validation-provider>
            <validation-provider #default="validationContext" :name="$t('unit.is_saturday')">
              <b-form-checkbox
                v-if="$can('bank_setting', 'Units')"
                id="is_saturday"
                v-model="itemData.is_saturday"
                name="is_saturday"
                class="my-1"
                switch
              >
                {{ $t("unit.is_saturday") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>

          <b-col cols="6">
            <!-- ID SEPROBAN moved up to avoid empty space -->
            <validation-provider
              #default="validationContext"
              :rules="'numeric'"
              name="Id Seproban"
              v-if="$can('bank_setting', 'Units')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.id_seproban')"
                label-for="id_seproban"
              >
                <b-form-input
                  id="id_seproban"
                  v-model="itemData.id_seproban"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            
            <validation-provider
              #default="validationContext"
              :name="$t('unit.id_cashier')"
              v-if="$can('bank_setting', 'Units')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.id_cashier')"
                label-for="id_cashier"
              >
                <b-form-input
                  id="id_cashier"
                  v-model="itemData.id_cashier"
                  :state="getValidationState(validationContext)"
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Comment field -->
            <validation-provider #default="validationContext" name="comments">
              <b-form-group
                class="mt-1"
                :label="$t('unit.disable_comment')"
                label-for="comments"
              >
                <b-form-textarea
                  id="comments"
                  v-model="itemData.comments"
                  :rows="$can('label_settings', 'Units') ? 8 : 4"
                  max-rows="6"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Etiqueta C5 Router -->
            <validation-provider #default="validationContext" name="c5_router_label">
              <b-form-group class="mt-1" :label="$t('unit.c5_router_label')" label-for="c5_router_label" v-if="$can('label_settings', 'Units')">
                <b-form-input
                  id="c5_router_label"
                  v-model="itemData.c5_router_label"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Fecha de configuración -->
            <validation-provider #default="validationContext" name="configuration_date">
              <b-form-group class="mt-1" :label="$t('unit.configuration_date')" label-for="configuration_date" v-if="$can('label_settings', 'Units')">
                <flat-pickr
                  id="configuration_date"
                  v-model="configurationDateModel"
                  :config="{
                    dateFormat: 'Y-m-d',
                    enableTime: false,
                    clickOpens: true
                  }"
                  class="form-control"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Fecha de instalación -->
            <validation-provider #default="validationContext" name="installation_date">
              <b-form-group class="mt-1" :label="$t('unit.installation_date')" label-for="installation_date" v-if="$can('label_settings', 'Units')">
                <flat-pickr
                  id="installation_date"
                  v-model="installationDateModel"
                  :config="{
                    dateFormat: 'Y-m-d',
                    enableTime: false,
                    clickOpens: true
                  }"
                  class="form-control"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6">
            <!--Permitir Botón Virtual -->
            <validation-provider name="vehicle" v-if="$can('advance_setting', 'Units')">
              <b-form-checkbox
                id="allow_virtual_button_alarm"
                v-model="itemData.allow_virtual_button_alarm"
                name="allow_virtual_button_alarm"
                value="1"
                unchecked-value="0"
                class="my-1"
                switch
              >
                {{ $t("unit.allow_virtual_button_alarm") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!--Permitir Salida Digital -->
            <validation-provider
              name="active_digital_output"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-checkbox
                id="active_digital_output"
                v-model="itemData.active_digital_output"
                name="active_digital_output"
                value="1"
                unchecked-value="0"
                class="my-1"
                switch
              >
                {{ $t("unit.active_digital_output") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <!-- notify_c5_cdmx -->
            <validation-provider
              name="notify_c5_cdmx"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-checkbox
                id="notify_c5_cdmx"
                v-model="itemData.notify_c5_cdmx"
                name="notify_c5_cdmx"
                value="1"
                unchecked-value="0"
                class="my-1 text-capitalize"
                switch
              >
                {{ $t("router.notify_cad_c5_cdmx") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- notify_c5_jal -->
            <validation-provider
              name="notify_c5_jal"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-checkbox
                id="notify_c5_jal"
                v-model="itemData.notify_c5_jal"
                name="notify_c5_jal"
                value="1"
                unchecked-value="0"
                class="my-1 text-capitalize"
                switch
              >
                {{ $t("router.notify_cad_c5_jalisco") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>
        </b-row>

        <!-- Agregar router adicional -->
        <div class="mt-2">
          <b-button variant="info" @click="addNewAdditionalRouter">
            {{ $t("router.add_new_router") }}
          </b-button>
        </div>

        <!-- Información del router -->
        <div class="mt-1 p-1 border-info rounded">
          <h5 class="mb-0"> {{ $t('router.information')}}</h5>
          <b-row>
            <!-- has_router -->
            <b-col cols="6">
              <validation-provider name="hasRouter">
                <b-form-checkbox
                  id="hasRouter"
                  v-model="itemData.hasRouter"
                  name="hasRouter"
                  value="1"
                  unchecked-value="0"
                  class="my-1 text-capitalize"
                  switch
                >
                  {{ $t("router.has_router") }}
                </b-form-checkbox>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <!-- force red mask -->
              <validation-provider
                name="force_network_mask"
                v-if="itemData.hasRouter == 1"
              >
                <b-form-checkbox
                  id="force_network_mask"
                  v-model="itemData.force_network_mask"
                  name="force_network_mask"
                  value="1"
                  unchecked-value="0"
                  class="my-1 text-capitalize"
                  switch
                  :disabled="!$can('advance_setting', 'Units')"
                >
                  {{ $t("router.force_network_mask") }}
                </b-form-checkbox>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <!-- IMEI -->
              <validation-provider
                #default="validationContext"
                name="imei"
                :rules="{ required_if: itemData.hasRouter == 1 }"
                v-if="itemData.hasRouter == 1 && $can('advance_setting', 'Units')"
              >
                <b-form-group :label="$t('router.imei')" label-for="imei">
                  <b-form-input
                    id="imei"
                    v-model="itemData.imei"
                    :state="getValidationState(validationContext)"
                    trim
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <!-- ip_vpn and mask -->
              <validation-provider
                #default="validationContext"
                name="ip_vpn"
                rules="ip"
                v-if="itemData.hasRouter == 1"
              >
                <InputIp
                  v-model="itemData.ip_vpn"
                  :mask.sync="itemData.subnet_mask"
                  :ip-state="getValidationState(validationContext)"
                  :required="false"
                  :show-errors="showIpErrors"
                  @on-validation="handleIpValidation"
                />
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <!-- needs_check -->
              <validation-provider
                name="needs_check"
              >
                <b-form-checkbox
                  id="needs_check"
                  v-model="itemData.needs_check"
                  name="needs_check"
                  value="1"
                  unchecked-value="0"
                  class="my-1 text-capitalize"
                  switch
                  :disabled="!$can('advance_setting', 'Units')"
                >
                  {{ $t("unit.needs_check") }}
                </b-form-checkbox>
              </validation-provider>
            </b-col>
          </b-row>
        </div>

        <!-- Routers adicionales --> 
        <div v-if="itemData.additional_routers.length > 0" v-for="(item, index) in itemData.additional_routers" :key="index">
          <div class="mt-1 p-1 border-info rounded">
            <h5 class="mb-0"> {{ $t('router.information') }} - {{ index + 1 }}</h5>
            <b-row>
              <!-- has_router -->
              <!-- <b-col cols="6">
                <validation-provider name="hasRouter">
                  <b-form-checkbox
                    :id="`hasRouter_${index}`"
                    v-model="item.hasRouter"
                    :name="`hasRouter_${index}`"
                    value="1"
                    unchecked-value="0"
                    class="my-1 text-capitalize"
                    switch
                  >
                    {{ $t("router.has_router") }}
                  </b-form-checkbox>
                </validation-provider>
              </b-col> -->
              <b-col cols="6">
                <!-- force red mask -->
                <validation-provider
                  name="force_network_mask"
                  v-if="item.hasRouter == 1"
                >
                  <b-form-checkbox
                    :id="`force_network_mask_${index}`"
                    v-model="item.force_network_mask"
                    :name="`force_network_mask_${index}`"
                    value="1"
                    unchecked-value="0"
                    class="my-1 text-capitalize"
                    switch
                    :disabled="!$can('advance_setting', 'Units')"
                  >
                    {{ $t("router.force_network_mask") }}
                  </b-form-checkbox>
                </validation-provider>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <!-- IMEI -->
                <validation-provider
                  #default="validationContext"
                  name="imei"
                  :rules="{ required_if: item.hasRouter == 1 }"
                  v-if="item.hasRouter == 1 && $can('advance_setting', 'Units')"
                >
                  <b-form-group :label="$t('router.imei')" label-for="imei2">
                    <b-form-input
                      :id="`imei_${index}`"
                      v-model="item.imei"
                      :state="getValidationState(validationContext)"
                      trim
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <!-- ip_vpn and mask -->
                <validation-provider
                  #default="validationContext"
                  :name="`ip_vpn_${index}`"
                  rules="ip"
                  v-if="item.hasRouter == 1"
                >
                  <InputIp
                    v-model="item.ip_vpn"
                    :mask.sync="item.subnet_mask"
                    :ip-state="getValidationState(validationContext)"
                    :required="false"
                    :show-errors="showIpErrors"
                    @on-validation="handleIpValidation"
                  />
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <!-- needs_check -->
                <validation-provider
                  name="needs_check"
                >
                  <b-form-checkbox
                    :id="`needs_check_${index}`"
                    v-model="item.needs_check"
                    :name="`needs_check_${index}`"
                    value="1"
                    unchecked-value="0"
                    class="my-1 text-capitalize"
                    switch
                    :disabled="!$can('advance_setting', 'Units')"
                  >
                    {{ $t("unit.needs_check") }}
                  </b-form-checkbox>
                </validation-provider>
              </b-col>
              <b-col cols="12 text-right">
                <b-button variant="outline-danger" @click="removeAdditionalRouter(index)" class="mb-2">
                  {{ $t("actions.delete") }}
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
        <!-- End of additional routers -->

        <b-row>
          <b-col cols="6">
            <!-- Mac Address -->
            <validation-provider #default="validationContext" name="mac_address">
              <b-form-group class="mt-1" :label="$t('unit.mac_address')" label-for="mac_address" v-if="$can('label_settings', 'Units') && itemData.hasRouter == 1">
                <b-form-input
                  id="mac_address"
                  v-model="itemData.mac_address"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Número de serie router -->
            <validation-provider #default="validationContext" name="router_serial_number">
              <b-form-group class="mt-1" :label="$t('unit.router_serial_number')" label-for="router_serial_number" v-if="$can('label_settings', 'Units') && itemData.hasRouter == 1">
                <b-form-input
                  id="router_serial_number"
                  v-model="itemData.router_serial_number"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
            <!-- Modelo Router -->
            <validation-provider #default="validationContext" name="router_model">
              <b-form-group class="mt-1" :label="$t('unit.router_model')" label-for="router_model" v-if="$can('label_settings', 'Units') && itemData.hasRouter == 1">
                <b-form-input
                  id="router_model"
                  v-model="itemData.router_model"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Marca de Router -->
            <validation-provider #default="validationContext" name="router_brand">
              <b-form-group class="mt-1" :label="$t('unit.router_brand')" label-for="router_brand" v-if="$can('label_settings', 'Units') && itemData.hasRouter == 1">
                <b-form-input
                  id="router_brand"
                  v-model="itemData.router_brand"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <!-- User -->
              <validation-provider #default="validationContext" name="user">
                <b-form-group class="mt-1" :label="$t('unit.user')" label-for="user" v-if="$can('label_settings', 'Units') && itemData.hasRouter == 1">
                  <b-form-input
                    id="user"
                    v-model="itemData.user"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <!-- Password -->
              <validation-provider #default="validationContext" name="password">
                <b-form-group class="mt-1" :label="$t('unit.password')" label-for="password" v-if="$can('label_settings', 'Units') && itemData.hasRouter == 1">
                  <b-input-group class="input-group-merge">
                    <b-form-input
                      id="password"
                      v-model="itemData.password"
                      :state="getValidationState(validationContext)"
                      :type="passwordFieldType"
                      class="form-control-merge"
                      trim
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        <b-row>
          <b-col cols="6">
            <!-- Es Vehiculo -->
            <validation-provider name="vehicle" v-if="$can('advance_setting', 'Units')">
              <b-form-checkbox
                id="vehicle"
                v-model="itemData.vehicle"
                name="vehicle"
                value="1"
                unchecked-value="0"
                class="my-1 text-capitalize"
                switch
              >
                {{ $t("unit.vehicle") }}
              </b-form-checkbox>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Ruta -->
            <validation-provider
              #default="validationContext"
              name="route"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.route')"
                label-for="route"
                v-if="itemData.vehicle == 1"
              >
                <b-form-input
                  id="route"
                  v-model="itemData.route"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <!-- Placa-->
            <validation-provider
              #default="validationContext"
              name="plate_number"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.plate_number')"
                label-for="plate_number"
                v-if="itemData.vehicle == 1"
              >
                <b-form-input
                  id="plate_number"
                  v-model="itemData.plate_number"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- VIN-->
            <validation-provider
              #default="validationContext"
              name="vin"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.vin')"
                label-for="vin"
                v-if="itemData.vehicle == 1"
              >
                <b-form-input
                  id="vin"
                  v-model="itemData.vin"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <!-- Conductor -->
            <validation-provider
              #default="validationContext"
              name="driver"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.driver')"
                label-for="driver"
                v-if="itemData.vehicle == 1"
              >
                <b-form-input
                  id="driver"
                  v-model="itemData.driver"
                  :state="getValidationState(validationContext)"
                  trim
                />

                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Proveedor-->
            <validation-provider
              #default="validationContext"
              name="provider"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.provider')"
                label-for="provider"
                v-if="itemData.vehicle == 1"
              >
                <b-form-input
                  id="provider"
                  v-model="itemData.provider"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <!-- Concesionario-->
            <validation-provider
              #default="validationContext"
              name="owner"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.owner')"
                label-for="owner"
                v-if="itemData.vehicle == 1"
              >
                <b-form-input
                  id="owner"
                  v-model="itemData.owner"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="6">
            <!-- Compañia-->
            <validation-provider
              #default="validationContext"
              name="company"
              v-if="$can('advance_setting', 'Units')"
            >
              <b-form-group
                class="text-capitalize"
                :label="$t('unit.company')"
                label-for="company"
                v-if="itemData.vehicle == 1"
              >
                <b-form-input
                  id="company"
                  v-model="itemData.company"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <!-- Disable Unit -->
            <validation-provider name="disable">
              <b-form-checkbox
                id="disable"
                v-model="itemData.isUnitDisabled"
                name="disable"
                class="my-1"
                switch
                @change="handleDisableChange"
              >
                {{ $t("unit.disable") }}
              </b-form-checkbox>
            </validation-provider>

            <!-- Unit Deactivation Catalog -->
            <validation-provider
              v-if="itemData.isUnitDisabled"
              #default="validationContext"
              :name="$tc('unit_deactivation_catalog.title', 1)"
              rules="required"
            >
              <b-form-group
                class="mt-1"
                :label="$tc('unit_deactivation_catalog.title', 1)"
                label-for="id_deactivation_catalog"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.router.deactivation.id_deactivation_catalog"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="unitDeactivationCatalogOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  input-id="id_deactivation_catalog"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Comment field -->
            <validation-provider
              v-if="itemData.isUnitDisabled"
              #default="validationContext"
              :name="$t('unit.disable_comment')"
              rules="required"
            >
              <b-form-group
                class="mt-1"
                :label="$t('unit.disable_comment')"
                label-for="disable_comment"
              >
                <b-form-textarea
                  id="disable_comment"
                  v-model="itemData.router.deactivation.comment"
                  rows="3"
                  max-rows="6"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <!-- Reactivation Date -->
            <validation-provider
              v-if="itemData.isUnitDisabled"
              #default="validationContext"
              name="reactivation_date"
            >
              <b-form-group
                class="mt-1"
                :label="$t('unit.reactivation_date')"
                label-for="reactivation_date"
              >
                <flat-pickr
                  v-model="itemData.router.deactivation.reactivation_date"
                  :config="{
                    dateFormat: 'Y-m-d H:i',
                    enableTime: true,
                    time_24hr: true,
                    minDate: new Date(new Date().getTime() + 5 * 60000),
                  }"
                  class="form-control mt-2"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <!-- Attachments Section -->
        <b-row v-if="itemData.isUnitDisabled">
          <b-col cols="12">
            <b-form-group
              class="mt-2"
              :label="$t('unit.attachments')"
              label-for="attachments"
            >
              <!-- Drop Zone -->
              <div
                class="file-drop-zone"
                :class="{ 'drag-over': isDragOver }"
                @drop.prevent="handleDrop"
                @dragover.prevent="isDragOver = true"
                @dragleave.prevent="isDragOver = false"
              >
                <div class="text-center p-3" v-if="attachments.length < 3">
                  <feather-icon icon="UploadCloudIcon" size="32" class="mb-1" />
                  <p class="mb-1">Arrastra archivos aquí</p>
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="$refs.fileInput.click()"
                  >
                    Seleccionar Archivos
                  </b-button>
                  <input
                    ref="fileInput"
                    type="file"
                    class="d-none"
                    multiple
                    accept=".pdf,.jpg,.jpeg,.png,.gif,.webp"
                    @change="handleFileSelect"
                  />
                  <p class="small text-muted mt-1 mb-0">
                    PDF e Imágenes (JPG, PNG, GIF, WEBP) - Máx. 3 archivos
                  </p>
                </div>
                <p v-else class="text-center text-muted mb-0 p-2">
                  Límite de archivos alcanzado (3/3)
                </p>
              </div>

              <!-- Files List -->
              <div v-if="attachments.length > 0" class="mt-2">
                <b-card
                  v-for="(file, index) in attachments"
                  :key="index"
                  class="mb-2"
                  no-body
                >
                  <b-card-body class="p-2">
                    <div class="d-flex align-items-center">
                      <!-- Preview/Icon -->
                      <div class="mr-2">
                        <img
                          v-if="file.preview"
                          :src="file.preview"
                          alt="preview"
                          class="file-preview-img"
                        />
                        <feather-icon
                          v-else
                          icon="FileTextIcon"
                          size="32"
                          class="text-danger"
                        />
                      </div>

                      <!-- File Info -->
                      <div class="flex-grow-1">
                        <div class="font-weight-bold">{{ file.name }}</div>
                        <small class="text-muted">
                          {{ formatFileSize(file.size) }}
                        </small>
                      </div>

                      <!-- Actions -->
                      <div>
                        <b-button
                          v-if="file.path"
                          variant="outline-primary"
                          size="sm"
                          class="mr-1"
                          @click="downloadFile(file)"
                        >
                          <feather-icon icon="DownloadIcon" size="16" />
                        </b-button>
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          @click="removeFile(index)"
                        >
                          <feather-icon icon="TrashIcon" size="16" />
                        </b-button>
                      </div>
                    </div>
                  </b-card-body>
                </b-card>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
  BFormRadio,
  BCard,
  BCardBody,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { required, alphaNum, email, positive, required_if } from "@validations";
import { ref, onMounted, watch, computed } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import flatPickr from "vue-flatpickr-component";
import InputIp from "@/components/InputIp/Index.vue";
import axios from "@axios";
import store from "@/store";
import _ from "lodash";

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    BFormCheckbox,
    BFormRadio,
    BCard,
    BCardBody,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    InputIp,
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true,
    },
    propItemData: {
      type: Object,
      required: true,
    },
    categoryOptions: {
      type: Array,
      required: true,
    },
    unitDeactivationCatalogOptions: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();
    const toast = useToast();
    const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));

    const trans = {
      "unit.file_limit_reached": t("unit.file_limit_reached"),
      "unit.file_limit_message": t("unit.file_limit_message"),
      "unit.invalid_file_type": t("unit.invalid_file_type"),
      "unit.invalid_file_message": t("unit.invalid_file_message"),
      "unit.downloading_file": t("unit.downloading_file"),
    };

    // Initialize mask_vpn if not present
    if (!itemData.value.subnet_mask) {
      // Use Vue.set if needed, but here it's a ref value assignment
      itemData.value.subnet_mask = "255.255.255.0";
    }
    
    const removeAdditionalRouter = (index) => {
      itemData.value.additional_routers.splice(index, 1);
    }

    const addNewAdditionalRouter = () => {
      itemData.value.additional_routers.push({
        hasRouter: 1,
        force_network_mask: 1,
        imei: "",
        ip_vpn: "",
        subnet_mask: "255.255.255.0",
        needs_check: 1,
      });
    }

    const isIpValid = ref(true);
    const showIpErrors = ref(false);
    const handleIpValidation = (isValid) => {
      isIpValid.value = isValid;
    };
    const toNullIfEmptyOrZero = (value) => {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        value === "0000-00-00" ||
        value === "0000-00-00 00:00:00"
      ) {
        return null;
      }
      return value;
    };

    const configurationDateModel = computed({
      get() {
        return toNullIfEmptyOrZero(itemData.value.configuration_date);
      },
      set(newValue) {
        itemData.value.configuration_date = toNullIfEmptyOrZero(newValue);
      },
    });

    const installationDateModel = computed({
      get() {
        return toNullIfEmptyOrZero(itemData.value.installation_date);
      },
      set(newValue) {
        itemData.value.installation_date = toNullIfEmptyOrZero(newValue);
      },
    });

    const validateStep = async () => {
      //console.log("Info Validate Step");

      if (!refFormObserver.value) {
        console.warn("La referencia refFormObserver es null");
        return false;
      }

      const validation = await refFormObserver.value.validate();

      // Mostrar errores de IP si hasRouter está activo
      if (itemData.value.hasRouter == 1) {
        showIpErrors.value = true;
        if (!isIpValid.value) {
          return false;
        }
      }

      return validation;
    };

    // Password visibility toggle state
    const passwordFieldType = ref("password");
    const passwordToggleIcon = computed(() => {
      return passwordFieldType.value === "password" ? "EyeIcon" : "EyeOffIcon";
    });
    const togglePasswordVisibility = () => {
      passwordFieldType.value =
        passwordFieldType.value === "password" ? "text" : "password";
    };

    const handleDisableChange = () => {
      itemData.value.isUnitDisabled = itemData.value.isUnitDisabled ? true : false;
      itemData.value.router.deactivation.deleted = itemData.value.isUnitDisabled ? 0 : 1;
    };

    // File handling
    const attachments = ref([]);
    const isDragOver = ref(false);
    const fileInput = ref(null);

    const isImageFile = (file) => {
      return file.type.startsWith("image/");
    };

    const handleFileSelect = (event) => {
      const files = Array.from(event.target.files);
      addFiles(files);
      event.target.value = ""; // Reset input
    };

    const handleDrop = (event) => {
      isDragOver.value = false;
      const files = Array.from(event.dataTransfer.files);
      addFiles(files);
    };

    const addFiles = (files) => {
      const remainingSlots = 3 - attachments.value.length;
      if (remainingSlots <= 0) {
        toast({
          component: ToastificationContent,
          props: {
            title: trans["unit.file_limit_reached"],
            text: trans["unit.file_limit_message"],
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      const filesToAdd = files.slice(0, remainingSlots);

      filesToAdd.forEach((file) => {
        // Validate file type
        const validTypes = [
          "application/pdf",
          "image/jpeg",
          "image/jpg",
          "image/png",
          "image/gif",
          "image/webp",
        ];
        if (!validTypes.includes(file.type)) {
          toast({
            component: ToastificationContent,
            props: {
              title: trans["unit.invalid_file_type"],
              text: trans["unit.invalid_file_message"].replace("{fileName}", file.name),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          return;
        }

        const fileData = {
          file: file,
          name: file.name,
          size: file.size,
          type: file.type,
          preview: null,
          path: null,
          isNew: true,
        };

        // Generate preview for images
        if (isImageFile(file)) {
          const reader = new FileReader();
          reader.onload = (e) => {
            fileData.preview = e.target.result;
          };
          reader.readAsDataURL(file);
        }

        attachments.value.push(fileData);
      });

      // Emit to parent
      emit("update:itemData", {
        router: {
          ...itemData.value.router,
          deactivation: {
            ...itemData.value.router?.deactivation,
            attachments: attachments.value,
          },
        },
      });
    };

    const removeFile = (index) => {
      attachments.value.splice(index, 1);

      // Emit to parent
      emit("update:itemData", {
        router: {
          ...itemData.value.router,
          deactivation: {
            ...itemData.value.router?.deactivation,
            attachments: attachments.value,
          },
        },
      });
    };

    const downloadFile = (file) => {
      if (!file.path) return;

      // Create temporary link and trigger download directly
      // This avoids CORS issues with /storage/ static files
      const link = document.createElement("a");
      link.href = file.path;
      link.download = file.name; // Suggests filename to browser
      link.target = "_blank"; // Fallback: open in new tab if download fails
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast({
        component: ToastificationContent,
        props: {
          title: trans["unit.downloading_file"],
          icon: "DownloadIcon",
          variant: "info",
        },
      });
    };

    const formatFileSize = (bytes) => {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
    };

    // Load existing attachments
    watch(
      () => props.propItemData,
      (newValue) => {
        itemData.value = newValue;

        if (!itemData.value.subnet_mask) {
          try {
            itemData.value.subnet_mask = "255.255.255.0";
          } catch (e) {
            // If immutable
          }
        }

        // Load attachments from backend
        if (newValue?.router?.deactivation?.attachments) {
          attachments.value = newValue.router.deactivation.attachments.map((att) => ({
            ...att,
            isNew: false,
            preview: att.type && att.type.startsWith("image/") ? att.path : null,
          }));
        }
      },
      { deep: true, immediate: true }
    );

    const setupWatcherNested = (itemData, keyPath) => {
      watch(
        () => _.get(itemData.value, keyPath), // Usamos _.get para acceder a propiedades anidadas de forma segura
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            let newDeactivation = {};
            if (keyPath == "router.deactivation.comment") {
              newDeactivation = {
                ...itemData.value.router?.deactivation,
                comment: newValue,
              };
            } else if (keyPath == "router.deactivation.reactivation_date") {
              newDeactivation = {
                ...itemData.value.router?.deactivation,
                reactivation_date: newValue,
              };
            } else if (keyPath == "router.deactivation.id_deactivation_catalog") {
              newDeactivation = {
                ...itemData.value.router?.deactivation,
                id_deactivation_catalog: newValue,
              };
            }
            emit("update:itemData", {
              router: {
                ...itemData.value.router,
                deactivation: newDeactivation,
              },
            });
          }
        },
        { deep: true }
      );
    };

    const setupWatcher = (itemData, key) => {
      watch(
        () => itemData.value[key],
        (newValue, oldValue) => {
          if (newValue !== oldValue) {
            emit("update:itemData", { [key]: newValue });
          }
        }
      );
    };

    setupWatcher(itemData, "description");
    setupWatcher(itemData, "reaction_patrol");
    setupWatcher(itemData, "idTotem");
    setupWatcher(itemData, "totemKey");
    setupWatcher(itemData, "allow_virtual_button_alarm");
    setupWatcher(itemData, "active_digital_output");
    setupWatcher(itemData, "notify_c5_cdmx");
    setupWatcher(itemData, "notify_c5_jal");
    setupWatcher(itemData, "vehicle");
    setupWatcher(itemData, "route");
    setupWatcher(itemData, "plate_number");
    setupWatcher(itemData, "vin");
    setupWatcher(itemData, "driver");
    setupWatcher(itemData, "provider");
    setupWatcher(itemData, "owner");
    setupWatcher(itemData, "company");
    setupWatcher(itemData, "comments");
    setupWatcher(itemData, "hasRouter");
    setupWatcher(itemData, "imei");
    setupWatcher(itemData, "ip_vpn");
    setupWatcher(itemData, "mask_vpn");
    setupWatcher(itemData, "router");
    setupWatcher(itemData, "isUnitDisabled");
    setupWatcher(itemData, "id_category");
    setupWatcherNested(itemData, "router.deactivation.comment");
    setupWatcherNested(itemData, "router.deactivation.reactivation_date");
    setupWatcherNested(itemData, "router.deactivation.id_deactivation_catalog");
    setupWatcher(itemData, "id_seproban");
    setupWatcher(itemData, "rems");
    setupWatcher(itemData, "sirh");
    setupWatcher(itemData, "needs_check");

    setupWatcher(itemData, "installation_date");
    setupWatcher(itemData, "c5_cabinet_label");
    setupWatcher(itemData, "router_serial_number");
    setupWatcher(itemData, "mac_address");
    setupWatcher(itemData, "router_brand");
    setupWatcher(itemData, "router_model");
    setupWatcher(itemData, "c5_router_label");
    setupWatcher(itemData, "brand_model");
    setupWatcher(itemData, "user");
    setupWatcher(itemData, "password");

    return {
      required,
      alphaNum,
      email,
      positive,
      required_if,
      itemData,
      refFormObserver,
      getValidationState,
      validateStep,
      handleIpValidation,
      showIpErrors,
      handleDisableChange,
      attachments,
      isDragOver,
      fileInput,
      handleFileSelect,
      handleDrop,
      removeFile,
      downloadFile,
      formatFileSize,
      configurationDateModel,
      installationDateModel,
      passwordFieldType,
      passwordToggleIcon,
      togglePasswordVisibility,
      removeAdditionalRouter,
      addNewAdditionalRouter,
    };
  },
};
</script>

<style scoped>
.file-drop-zone {
  border: 2px dashed #d8d6de;
  border-radius: 0.357rem;
  background-color: #f8f8f8;
  transition: all 0.2s ease;
  cursor: pointer;
}

.file-drop-zone.drag-over {
  border-color: #7367f0;
  background-color: #f3f2f7;
}

.file-preview-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 0.357rem;
}
</style>
